import { render, staticRenderFns } from "./Classi.vue?vue&type=template&id=320e8729"
import script from "./Classi.vue?vue&type=script&lang=js"
export * from "./Classi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports